// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React, {useEffect, useState} from "react";
import {Element} from "react-scroll";
import {getUser, putUser} from "../../../../api/userService";

const Gegevens = ({
                    initialEmail,
                    initialFirstName,
                    initialLastName,
                    onRefresh,
                  }
) => {
  const textColor = useColorModeValue("gray.700", "white");

  const [isProcessing, setIsProcessing] = useState(false);

  // Userdata
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);

  const processUserdata = async () => {
    let changed = false;
    if (initialFirstName !== firstName){
      changed = true;
    }
    if (initialLastName !== lastName){
      changed = true;
    }

    if(changed){
      const response = await putUser(firstName, lastName);
      onRefresh();
    }
  }


  return (
    <Card
      w={{sm: "100%", lg: "70%"}}
      alignSelf="flex-end"
      justifySelf="flex-end"
    >
      <Element id="gegevens" name="gegevens">
        <CardHeader mb="40px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold">
              Gegevens
            </Text>
            <Text color="gray.400" fontWeight="normal" fontSize="sm">
              Om u zo goed mogelijk van dienst te zijn hebben we de volgende gegevens nodig.
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <Stack direction="column" spacing="20px" w="100%">
            <Stack direction="row" spacing={{sm: "24px", lg: "30px"}}>
              <FormControl>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  Voornaam
                </FormLabel>
                <Input
                  borderRadius="15px"
                  onChange={(e) => setFirstName(e.target.value)}
                  value={firstName}
                  fontSize="xs"
                />
              </FormControl>
              <FormControl>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  Achternaam
                </FormLabel>
                <Input
                  borderRadius="15px"
                  onChange={(e) => setLastName(e.target.value)}
                  value={lastName}
                  fontSize="xs"
                />
              </FormControl>
            </Stack>
            {/*<Stack*/}
            {/*  direction={{sm: "column", lg: "row"}}*/}
            {/*  spacing={{sm: "24px", lg: "30px"}}*/}
            {/*>*/}
            {/*  <FormControl w="40%">*/}
            {/*    <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">*/}
            {/*      Geslacht*/}
            {/*    </FormLabel>*/}
            {/*    <Select*/}
            {/*      borderRadius="15px"*/}
            {/*      color="gray.400"*/}
            {/*      fontSize="xs"*/}
            {/*    >*/}
            {/*      <option value="option1">Man</option>*/}
            {/*      <option value="option2">Vrouw</option>*/}
            {/*    </Select>*/}
            {/*  </FormControl>*/}
            {/*  <Stack*/}
            {/*    direction="row"*/}
            {/*    spacing={{sm: "24px", lg: "30px"}}*/}
            {/*    w="100%"*/}
            {/*    align="flex-end"*/}
            {/*  >*/}
            {/*    <FormControl minW={{sm: "35%", lg: null}}>*/}
            {/*      <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">*/}
            {/*        Geboortedatum*/}
            {/*      </FormLabel>*/}
            {/*      <Select*/}
            {/*        borderRadius="15px"*/}
            {/*        color="gray.400"*/}
            {/*        fontSize="sm"*/}
            {/*        fontSize="xs"*/}
            {/*      >*/}
            {/*        <option value="option1">Januari</option>*/}
            {/*        <option value="option2">Februari</option>*/}
            {/*        <option value="option3">Maart</option>*/}
            {/*        <option value="option4">April</option>*/}
            {/*        <option value="option5">Mei</option>*/}
            {/*        <option value="option6">Juni</option>*/}
            {/*        <option value="option7">Juli</option>*/}
            {/*        <option value="option8">Augustus</option>*/}
            {/*        <option value="option9">September</option>*/}
            {/*        <option value="option10">Oktober</option>*/}
            {/*        <option value="option11">November</option>*/}
            {/*        <option value="option12">December</option>*/}
            {/*      </Select>*/}
            {/*    </FormControl>*/}
            {/*    <FormControl>*/}
            {/*      <Select*/}
            {/*        borderRadius="15px"*/}
            {/*        color="gray.400"*/}
            {/*        placeholder="1"*/}
            {/*        fontSize="xs"*/}
            {/*      >*/}
            {/*        <option value="option2">2</option>*/}
            {/*        <option value="option3">3</option>*/}
            {/*        <option value="option4">4</option>*/}
            {/*        <option value="option5">5</option>*/}
            {/*        <option value="option6">6</option>*/}
            {/*        <option value="option7">7</option>*/}
            {/*        <option value="option8">-</option>*/}
            {/*      </Select>*/}
            {/*    </FormControl>*/}
            {/*    <FormControl>*/}
            {/*      <Select*/}
            {/*        borderRadius="15px"*/}
            {/*        color="gray.400"*/}
            {/*        placeholder="2010"*/}
            {/*        fontSize="xs"*/}
            {/*      >*/}
            {/*        <option value="option2">2011</option>*/}
            {/*        <option value="option3">2012</option>*/}
            {/*        <option value="option4">2013</option>*/}
            {/*        <option value="option5">2014</option>*/}
            {/*        <option value="option6">2015</option>*/}
            {/*        <option value="option7">2016</option>*/}
            {/*        <option value="option8">2018</option>*/}
            {/*        <option value="option8">2019</option>*/}
            {/*        <option value="option8">2020</option>*/}
            {/*        <option value="option8">2021</option>*/}
            {/*      </Select>*/}
            {/*    </FormControl>*/}
            {/*  </Stack>*/}
            {/*</Stack>*/}
            <Stack direction="row" spacing={{sm: "24px", lg: "30px"}}>
              <FormControl>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  Emailadres
                </FormLabel>
                <Input
                  isDisabled={true}
                  borderRadius="15px"
                  value={initialEmail}
                  fontSize="xs"
                />
              </FormControl>
              <FormControl>
                {/*<FormLabel fontWeight="semibold" fontSize="xs" mb="10px">*/}
                {/*  Factuur emailadres*/}
                {/*</FormLabel>*/}
                {/*<Input*/}
                {/*  borderRadius="15px"*/}
                {/*  placeholder={initialEmail}*/}
                {/*  fontSize="xs"*/}
                {/*/>*/}
              </FormControl>
            </Stack>
          {/*  <Stack direction="row" spacing={{sm: "24px", lg: "30px"}}>*/}
          {/*    <FormControl>*/}
          {/*      <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">*/}
          {/*        BTW Nummer*/}
          {/*      </FormLabel>*/}
          {/*      <Input*/}
          {/*        borderRadius="15px"*/}
          {/*        placeholder=""*/}
          {/*        fontSize="xs"*/}
          {/*      />*/}
          {/*    </FormControl>*/}
          {/*    <FormControl>*/}
          {/*      <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">*/}
          {/*        Telefoonnummer*/}
          {/*      </FormLabel>*/}
          {/*      <Input*/}
          {/*        borderRadius="15px"*/}
          {/*        placeholder="bijv.  0612345678"*/}
          {/*        fontSize="xs"*/}
          {/*      />*/}
          {/*    </FormControl>*/}
          {/*  </Stack>*/}
          </Stack>
        </CardBody>
        <CardBody>
          <Flex
            direction={{ sm: "column", md: "row" }}
            justify="space-between"
            align="start"
            w="100%"
            py="10"
          >
            <Flex align="center" mb={{ sm: "16px", lg: null }}>
            </Flex>
            <Flex align="center">
              <Button
                isLoading={isProcessing}
                isDisabled={isProcessing}
                variant="outline"
                colorScheme="black"
                w="120px"
                h="35px"
                fontSize="xs"
                me="14px"
                onClick={async () => {
                  setIsProcessing(true);
                  await processUserdata();
                  setIsProcessing(false);
                }}
              >
                OPSLAAN
              </Button>
            </Flex>
          </Flex>
        </CardBody>
      </Element>
    </Card>
  );
};

export default Gegevens;
